import { OrganizationMember } from '@prisma/client'
import { useSdk } from './useSdk'

type Props = {
  organizationMember: OrganizationMember
  conversationId: string
}

export const useConversation = ({
  conversationId,
  organizationMember,
}: Props) => {
  const sdk = useSdk({ organizationMember })

  const clearConversation = async () => {
    await sdk.clearConversation({ conversationId })
    window.location.reload()
  }

  return { clearConversation }
}
